module.exports = __webpack_public_path__ + "img/celular3.4fb0405c.svg";